import apiService from './api-service'

const reportService = {}

/**
 * Retrieve an Excell Report by it's id
 * @param  array params (optional)
 * @return report
 */
reportService.getFile = function (page, params) {
  return apiService.get(`/report${page}`, { params }).then(res => res.data)
}

export default reportService



// WEBPACK FOOTER //
// ./src/services/reports.js